import { Roles, UserType } from 'infrastructure/enums';

const CCMRoles = [
  Roles.Biller,
  Roles.Doctor,
  Roles.NursePractitioner,
  Roles.PhysicianAssistant,
  Roles.MedicalAssistant,
  Roles.QHCP,
  Roles.Support,
  Roles.RegisteredNurse,
];

const CCMSpecialistRoles = [
  Roles.PhysicianAssistant,
  Roles.Doctor,
  Roles.NursePractitioner,
  Roles.MedicalAssistant,
  Roles.QHCP,
  Roles.RegisteredNurse,
];

const CCMOnboardingAgentRoles = [...CCMRoles, Roles.PatientAcceptance];

const AppointmentCompletedByAllowedRoles = [Roles.QHCP, Roles.RegisteredNurse];

const RpmDashboardFilterDoctorSearchRoles = [
  Roles.Doctor,
  Roles.NursePractitioner,
  Roles.RegisteredNurse,
  Roles.PhysicianAssistant,
  Roles.MedicalAssistant,
  Roles.PharmD,
];

const AccessToMainPageRoles = [
  Roles.Support,
  Roles.Onboarding,
  Roles.Biller,
  Roles.Default,
  Roles.Doctor,
  Roles.NursePractitioner,
  Roles.PhysicianAssistant,
  Roles.MedicalAssistant,
  Roles.RegisteredNurse,
  Roles.QHCP,
  Roles.PharmD,
  Roles.Clinical,
  Roles.ClientSuccessOnboarding,
  Roles.SalesRepresentative,
  Roles.ClientSuccessScaling,
];

const ClinicalRoles = [
  Roles.Doctor,
  Roles.NursePractitioner,
  Roles.PhysicianAssistant,
  Roles.MedicalAssistant,
  Roles.RegisteredNurse,
  Roles.QHCP,
  Roles.PharmD,
  Roles.Clinical,
];

const CallDashboardRoles = [
  Roles.CallDashboard,
  Roles.Supervisor,
  Roles.CallAgent,
];

const CallDashboardMetricsRoles = [Roles.Supervisor, Roles.CallAgent];

const ReadOnlyRoles = [
  Roles.Biller,
  Roles.ClientSuccessOnboarding,
  Roles.SalesRepresentative,
  Roles.ClientSuccessScaling,
];

const SmsDashboardRoles = [Roles.SmsDashboard, Roles.SmsDashboardUnregistered];

const TrackableRoles = [
  Roles.Doctor,
  Roles.NursePractitioner,
  Roles.PhysicianAssistant,
  Roles.MedicalAssistant,
  Roles.RegisteredNurse,
  Roles.QHCP,
  Roles.PharmD,
];
const NotTrackableRoles = [Roles.Support, Roles.Onboarding];
const TrackableHhaRoles = [
  Roles.Doctor,
  Roles.NursePractitioner,
  Roles.PhysicianAssistant,
  Roles.MedicalAssistant,
  Roles.RegisteredNurse,
  Roles.QHCP,
];
const CcmTrackableHhaRoles = [
  Roles.PhysicianAssistant,
  Roles.MedicalAssistant,
  Roles.Doctor,
  Roles.QHCP,
  Roles.NursePractitioner,
  Roles.RegisteredNurse,
];
const ReadOnlyHhaRoles = [
  Roles.Biller,
  Roles.ClientSuccessOnboarding,
  Roles.SalesRepresentative,
  Roles.ClientSuccessScaling,
];

const AccessRolesMap = {
  [UserType.Admin]: [Roles.Default, Roles.Clinical],
  [UserType.HomeHealth]: [
    ...TrackableHhaRoles,
    ...NotTrackableRoles,
    ...CcmTrackableHhaRoles,
    ...ReadOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
    Roles.MedicalAssistant,
    Roles.PatientAcceptance,
  ],
  [UserType.Practice]: [
    ...TrackableRoles,
    ...NotTrackableRoles,
    Roles.Biller,
    Roles.MedicalAssistant,
    Roles.PatientAcceptance,
  ],
  [UserType.Patient]: [],
};

// banner
const CarePlanDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...TrackableHhaRoles, ...ReadOnlyHhaRoles],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

const VitalsReportDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};

const SlaFlagDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [...TrackableRoles, ...NotTrackableRoles, Roles.Biller],
  [UserType.Patient]: [],
};

const ContactAvailabilityDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ReadOnlyHhaRoles],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// control panel
const GeneralCommentsDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ReadOnlyHhaRoles],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
const GeneralCommentsPrmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const GeneralCommentsCcmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...TrackableHhaRoles, ...ReadOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const RpmCallAndSmsButtonsDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const CcmCallAndSmsButtonsDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...TrackableHhaRoles, ...ReadOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const CreateCaseInEHRDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [],
  [UserType.Practice]: [...TrackableRoles, ...NotTrackableRoles, Roles.Biller],
  [UserType.Patient]: [],
};
const CreateCaseInEHRRpmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...CcmTrackableHhaRoles,
    ...ReadOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [...TrackableRoles, ...NotTrackableRoles, Roles.Biller],
  [UserType.Patient]: [],
};
const CreateCaseInEHRCcmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...TrackableHhaRoles,
    ...ReadOnlyHhaRoles,
    Roles.Biller,
  ],
  [UserType.Practice]: [...TrackableRoles, ...NotTrackableRoles, Roles.Biller],
  [UserType.Patient]: [],
};
const CreateCaseInEHRDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...TrackableHhaRoles, ...ReadOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const HoldingStatusDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ReadOnlyHhaRoles, Roles.Biller],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
const TemporaryHoldDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...TrackableHhaRoles, ...ReadOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const AwaitingConsumablesDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const RequestsButtonDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const CriticalEscalationDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [...TrackableRoles, ...NotTrackableRoles, Roles.Biller],
  [UserType.Patient]: [],
};
const CriticalEscalationDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...ReadOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const FollowUpAppointmentDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...TrackableHhaRoles, ...ReadOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const FollowUpAppointmentDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [Roles.Biller],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// interaction time
const InteractionTimeRpmDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const InteractionTimeCcmDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...TrackableHhaRoles, ...ReadOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const InteractionTimeAddTimeRpmDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...TrackableHhaRoles,
    ...CcmTrackableHhaRoles,
    ...ReadOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
const InteractionTimeAddTimeCcmDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...TrackableHhaRoles,
    ...ReadOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// averages
const AveragesDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};

// past medical history
const PastMedicalHistoryDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...TrackableHhaRoles,
    ...ReadOnlyHhaRoles,
    Roles.PatientAcceptance,
  ],
  [UserType.Practice]: [Roles.PatientAcceptance],
  [UserType.Patient]: [],
};

const AddPastMedicalHistoryDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [Roles.Biller, Roles.PatientAcceptance],
  [UserType.Practice]: [Roles.Biller, Roles.PatientAcceptance],
  [UserType.Patient]: [],
};

// clinical activity and clinical interventions
const VoiceCallRpmDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};

const VoiceCallCcmDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...TrackableHhaRoles, ...ReadOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const SmsRpmActivityDenyRolesMap = structuredClone(VoiceCallRpmDenyRolesMap);
const SmsCcmActivityDenyRolesMap = structuredClone(VoiceCallCcmDenyRolesMap);
const ManualClinicalNotesRpmDenyRolesMap = structuredClone(
  VoiceCallRpmDenyRolesMap,
);
const ManualClinicalNotesCcmDenyRolesMap = structuredClone(
  VoiceCallCcmDenyRolesMap,
);
const ClinicalNotesRpmDenyRolesMap = structuredClone(VoiceCallRpmDenyRolesMap);
const ClinicalNotesCcmDenyRolesMap = structuredClone(VoiceCallCcmDenyRolesMap);
const AddClinicalNotesCcmDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [Roles.Biller],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// activity
const ActivityDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const SendCommentDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, ...ReadOnlyHhaRoles],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
const ReviewDisableRolesMap = structuredClone(SendCommentDisableRolesMap);
const AiCommentDisableRolesMap = structuredClone(SendCommentDisableRolesMap);
const BookmarkedCommentsDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...TrackableHhaRoles,
    ...CcmTrackableHhaRoles,
    ...ReadOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
const BookmarkedCommentsDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...TrackableHhaRoles,
    ...CcmTrackableHhaRoles,
    ...ReadOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const RpmCommentTemplateDisableRolesMap = structuredClone(
  SendCommentDisableRolesMap,
);

// key notes
const KeyNoteRpmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const AddEditRpmKeyNoteDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...CcmTrackableHhaRoles,
    ...ReadOnlyHhaRoles,
    Roles.Support,
    Roles.Biller,
  ],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
const KeyNoteCcmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...TrackableHhaRoles, ...ReadOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const AddEditCcmKeyNoteDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...TrackableHhaRoles,
    ...ReadOnlyHhaRoles,
    Roles.Biller,
  ],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// services
const ServicesCcmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...TrackableHhaRoles, ...ReadOnlyHhaRoles],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};
const ServicesCcmTabDisableRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [
    ...TrackableHhaRoles,
    ...ReadOnlyHhaRoles,
    Roles.Biller,
  ],
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};
const ServicesRpmTabDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: [...CcmTrackableHhaRoles, Roles.Support, Roles.Biller],
  [UserType.Practice]: [],
  [UserType.Patient]: [],
};

// medication
const AddMedicationDisabledRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: ReadOnlyHhaRoles,
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

// read only roles
const ReadOnlyDenyRolesMap = {
  [UserType.Admin]: [],
  [UserType.HomeHealth]: ReadOnlyHhaRoles,
  [UserType.Practice]: [Roles.Biller],
  [UserType.Patient]: [],
};

export const RoleGroups = {
  CCMRoles,
  CCMSpecialistRoles,
  CCMOnboardingAgentRoles,
  AppointmentCompletedByAllowedRoles,
  RpmDashboardFilterDoctorSearchRoles,
  AccessToMainPageRoles,
  ClinicalRoles,
  CallDashboardRoles,
  CallDashboardMetricsRoles,
  ReadOnlyRoles,
  SmsDashboardRoles,
  TrackableRoles,
  NotTrackableRoles,
  TrackableHhaRoles,
  CcmTrackableHhaRoles,
  ReadOnlyHhaRoles,
  AccessRolesMap,
  CarePlanDenyRolesMap,
  VitalsReportDenyRolesMap,
  SlaFlagDenyRolesMap,
  ContactAvailabilityDisableRolesMap,
  ReadOnlyDenyRolesMap,
  VoiceCallRpmDenyRolesMap,
  VoiceCallCcmDenyRolesMap,
  SmsRpmActivityDenyRolesMap,
  SmsCcmActivityDenyRolesMap,
  ManualClinicalNotesRpmDenyRolesMap,
  ManualClinicalNotesCcmDenyRolesMap,
  ClinicalNotesRpmDenyRolesMap,
  ClinicalNotesCcmDenyRolesMap,
  GeneralCommentsDenyRolesMap,
  GeneralCommentsPrmTabDenyRolesMap,
  GeneralCommentsCcmTabDenyRolesMap,
  RpmCallAndSmsButtonsDenyRolesMap,
  CcmCallAndSmsButtonsDenyRolesMap,
  CreateCaseInEHRDenyRolesMap,
  CreateCaseInEHRRpmTabDenyRolesMap,
  CreateCaseInEHRCcmTabDenyRolesMap,
  CreateCaseInEHRDisableRolesMap,
  HoldingStatusDenyRolesMap,
  TemporaryHoldDenyRolesMap,
  AwaitingConsumablesDenyRolesMap,
  RequestsButtonDenyRolesMap,
  CriticalEscalationDenyRolesMap,
  CriticalEscalationDisableRolesMap,
  FollowUpAppointmentDenyRolesMap,
  FollowUpAppointmentDisableRolesMap,
  InteractionTimeRpmDenyRolesMap,
  InteractionTimeCcmDenyRolesMap,
  InteractionTimeAddTimeRpmDenyRolesMap,
  InteractionTimeAddTimeCcmDenyRolesMap,
  AveragesDenyRolesMap,
  PastMedicalHistoryDenyRolesMap,
  AddPastMedicalHistoryDisableRolesMap,
  AddClinicalNotesCcmDisableRolesMap,
  ActivityDenyRolesMap,
  ReviewDisableRolesMap,
  AiCommentDisableRolesMap,
  BookmarkedCommentsDisableRolesMap,
  BookmarkedCommentsDenyRolesMap,
  RpmCommentTemplateDisableRolesMap,
  KeyNoteRpmTabDenyRolesMap,
  AddEditRpmKeyNoteDisableRolesMap,
  KeyNoteCcmTabDenyRolesMap,
  AddEditCcmKeyNoteDisableRolesMap,
  ServicesCcmTabDenyRolesMap,
  ServicesCcmTabDisableRolesMap,
  ServicesRpmTabDenyRolesMap,
  AddMedicationDisabledRolesMap,
} as const;
